// import { useMutation } from "@tanstack/react-query";
import { Modal, Button, Row, Col, message } from "antd";

import { FC, useEffect, useState } from "react";
import { CashManagementRecord, ICMBreakDownRecord } from "../../../../../types/cash-management";
import { CMBreakDownTable } from "./CMBreakDownTable";
import { PlusOutlined } from "@ant-design/icons";
import { cashManagementService } from "../../../../../services/cash-management";

interface ICMBreakDownModal {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  breakDownRecord?: CashManagementRecord | undefined;
  setSelectedBreakdownRecord: React.Dispatch<React.SetStateAction<CashManagementRecord | undefined>>;
}

export const CMBreakDownModal: FC<ICMBreakDownModal> = ({ visible, setVisible, breakDownRecord, setSelectedBreakdownRecord }) => {
  const [editingKey, setEditingKey] = useState<number | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [dataToDelete, setDataToDelete] = useState<(number | string)[]>([]);

  const [data, setData] = useState<ICMBreakDownRecord[]>([]);

  const onCancel = () => {
    setSelectedBreakdownRecord(undefined);
    setVisible(false);
    setEditingKey(undefined);
    setData([]);
    setDataToDelete([]);
  };

  const onSave = async () => {
    const missingGLCode = data.some((item) => !item.GLCodeID);
    if (missingGLCode) return message.info("Please select a GL Code for all breakdowns");

    const sum = data.reduce((sum, item) => sum + (item.Amount || 0), 0);

    if (sum !== breakDownRecord?.amount) return message.info(`The sum of all the amounts must be ${breakDownRecord?.amount}`);

    setIsLoading(true);
    const resp = await cashManagementService.saveBreakdowns({
      breakdowns: data,
      deleteArr: dataToDelete
    });

    if (resp.ok) message.success(`Amount breakdown(s) saved`);
    else message.error("Ups! Something went wrong, please try again later or contact the support team");
    onCancel();
    setIsLoading(false);
  };

  const buttons = [
    <Button
      key="cancel"
      color="red"
      onClick={() => {
        handleCancel();
      }}
    >
      Close
    </Button>,
    <Button
      key="save"
      type="primary"
      onClick={() => {
        onSave();
      }}
      disabled={!!editingKey}
    >
      Save & Close
    </Button>
  ];

  const fetchData = async () => {
    const id = breakDownRecord?.id;
    if (!id) return setData([]);

    const br = await cashManagementService.getBreakdowns(id);
    if (!br.ok) {
      message.error("Error fetching breakdowns");
      return setData([]);
    }
    return setData(br.data || []);
  };

  useEffect(() => {
    if (!breakDownRecord) return onCancel();
    setIsLoading(true);
    fetchData().finally(() => {
      setIsLoading(false);
    });
  }, [breakDownRecord]);

  const createNewBreakDown = async () => {
    // try {
    // setIsLoading(true);
    const recordToEditAux: ICMBreakDownRecord = {
      GLCodeID: undefined,
      Amount: 0,
      Description: "",
      RecordID: breakDownRecord?.id!,
      ID: -new Date().getTime() // Temporary ID for the new record
    };

    // const resp = await cashManagementService.saveBreakdowns([recordToEditAux]);

    // if (!resp.ok) {
    //   setIsLoading(false);
    //   return message.error("Ups! Something went wrong, please try again later or contact the support team");
    // }
    // message.success(`Amount breakdown created`);
    // const newBD: ICMBreakDownRecord = resp.data[0];
    setData((data) => [...data, recordToEditAux]);
    setEditingKey(recordToEditAux.ID);
    // } catch (error) {
    //   console.error(error);
    //   message.error("Ups! Something went wrong, please try again later or contact the support team");
    // }

    // setIsLoading(false);
  };

  const handleCancel = () => {
    if (editingKey !== -1) {
      Modal.confirm({
        title: "You may have unsaved changes",
        content: "Are you sure you want to close?",
        onOk: () => onCancel()
      });

      return;
    }

    onCancel();
  };

  return (
    <>
      <Modal
        destroyOnClose
        maskClosable={false}
        visible={visible}
        title={
          <p>
            Total amount: $ <b>{breakDownRecord?.amount}</b>
            <Button
              disabled={!!editingKey || isLoading}
              color="default"
              type="text"
              onClick={() => createNewBreakDown()}
              icon={<PlusOutlined />}
            >
              <b style={{ marginLeft: 5 }}>Create breakdown</b>
            </Button>
          </p>
        }
        centered
        onCancel={() => handleCancel()}
        onOk={() => {}}
        footer={buttons}
      >
        <Row>
          <Col span={24}>
            <CMBreakDownTable
              setDataToDelete={setDataToDelete}
              fetchData={fetchData}
              breakDownRecord={breakDownRecord}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              data={data}
              editingKey={editingKey}
              setEditingKey={setEditingKey}
              setData={setData}
            />
          </Col>
        </Row>
      </Modal>
    </>
  );
};
